/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ClarityModule } from '@clr/angular';

import { IconAliasesPipe } from './icon-shapes/icon-details/icon-aliases.pipe';
import { IconAriaLabelPipe } from './icon-shapes/icon-details/icon-aria-label.pipe';
import { IconCodePipe } from './icon-shapes/icon-details/icon-code.pipe';
import { IconDetailsComponent } from './icon-shapes/icon-details/icon-details.component';
import { IconVariantsPipe } from './icon-shapes/icon-details/icon-variants.pipe';
import { IconBadgePipe } from './icon-shapes/icon-groups/icon-badge.pipe';
import { IconGroupsComponent } from './icon-shapes/icon-groups/icon-groups.component';
import { IconSearchPipe } from './icon-shapes/icon-groups/icon-search.pipe';
import { IconShapesComponent } from './icon-shapes/icon-shapes.component';
import { IconsDemo } from './icons.demo';
import { SiteFooterModule } from '../../../site-footer/site-footer.module';
import { UtilsModule } from '../../../utils/utils.module';
import { DocTabsModule } from '../_doc-tabs/doc-tabs.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ClarityModule,
    DocTabsModule,
    UtilsModule,
    SiteFooterModule,
    RouterModule.forChild([{ path: '', component: IconsDemo }]),
  ],
  declarations: [
    IconsDemo,
    IconShapesComponent,
    IconGroupsComponent,
    IconDetailsComponent,
    IconAliasesPipe,
    IconAriaLabelPipe,
    IconBadgePipe,
    IconCodePipe,
    IconSearchPipe,
    IconVariantsPipe,
  ],
  exports: [IconsDemo],
})
export class IconsDemoModule {}
